import { PlexForGoodTranslations } from './types'
import { generateDefaultMessage } from './utils'

/**
 * Default translations used as fallbacks when Contentful content is not available
 */
export const defaultTranslations: PlexForGoodTranslations = {
    zeroPlexMessage: generateDefaultMessage('You need to own PLEX to donate'),
    loginToDonate: generateDefaultMessage('Log in to donate'),
    campaignHasEnded: generateDefaultMessage('Campaign has ended'),
    donationFormDescription: generateDefaultMessage(
        'Choose a fixed PLEX amount or enter your own to support a cause that matters. Every PLEX counts toward creating real-world impact.'
    ),
    enterAmountOf: generateDefaultMessage('Enter amount of '),
    plexBalance: generateDefaultMessage('Plex Balance: '),
    needMorePlex: generateDefaultMessage('Need more PLEX?'),
    selectCharacterPlaceHolder: generateDefaultMessage(
        'Select character as the donor'
    ),
    donatePlex: generateDefaultMessage('Donate Plex'),
    mustHaveCharacter: generateDefaultMessage(
        'You need at least one character to donate PLEX. Please create a character in EVE Online first.'
    ),
    thankYouTitle: generateDefaultMessage('Thank you for your donation!'),
    thankYouMessage: generateDefaultMessage(
        "Your contribution helps provide vital aid and support to those who need it most. With every PLEX, we're making the world a better place—together!"
    ),
    donationDetailsFormat: generateDefaultMessage(
        '{amount} PLEX donated to {campaignTitle}'
    ),
    // Validation error messages
    errorSelectCampaign: generateDefaultMessage('Please select a campaign'),
    errorInvalidAmount: generateDefaultMessage(
        'Please enter a valid donation amount'
    ),
    errorInsufficientPlex: generateDefaultMessage('Insufficient PLEX balance'),
    errorSelectCharacter: generateDefaultMessage('Please select a character'),
    errorInvalidCampaign: generateDefaultMessage(
        'Campaign information is invalid or no longer active.'
    ),
    errorServerIssue: generateDefaultMessage(
        'The server is experiencing issues. Please try again later.'
    ),
    errorSessionExpired: generateDefaultMessage(
        'Your session has expired. Please log in again.'
    ),
    errorUnexpected: generateDefaultMessage(
        'An unexpected error occurred. Please try again later.'
    ),
    failedToFetchPlexBalance: generateDefaultMessage(
        'Failed to fetch PLEX balance, please try again later.'
    ),
}
